import { BookLaunchOffer } from '../models/book_launch_offer.model'
import { BookPriceOffer } from '../models/vouchers/book_price_offer.model'

import { DecimalPipe } from '@angular/common';
export class TierInfo {

  i18n: string = ''
  currency: string = ''
  tier: BookPriceOffer | undefined
  bookLaunchOffer: BookLaunchOffer | undefined

  constructor(
    i18n: string,
    currency: string,
    tier: BookPriceOffer | undefined = undefined,
    bookLaunchOffer: BookLaunchOffer | undefined = undefined,
  ) {
    this.i18n = i18n
    this.currency = currency
    this.tier = tier
    this.bookLaunchOffer = bookLaunchOffer
  }

  get freeSocialMediaPost(): boolean {
    const quantity = this.tier?.quantity || 0
    return quantity > 20;
  }

  get freeBiographyPage(): boolean {
    const quantity = this.tier?.quantity || 0
    return quantity > 50;
  }

  get freePromotionalVideo(): boolean {
    const quantity = this.tier?.quantity || 0
    return quantity > 100;
  }

  get discount(): number {
    return this.tier?.discount?.percentage || 0
  }

  get renderIncluded(): boolean {
    if (this.i18n === 'book_price_offer.tier_info.discount_info') {
      return true
    } else if (this.i18n === 'book_price_offer.tier_info.price_reduction_info') {
      return this.old_price !== this.new_price
    } else if (this.i18n === 'book_price_offer.tier_info.free_additional_copies') {
      return this.quantity > 0
    } else if (this.i18n === 'book_price_offer.tier_info.free_social_media_post') {
      return this.freeSocialMediaPost
    } else if (this.i18n === 'book_price_offer.tier_info.free_biography_page') {
      return this.freeBiographyPage
    } else if (this.i18n === 'book_price_offer.tier_info.free_promotional_video') {
      return this.freePromotionalVideo
    } else {
      return false
    }
  }

  get renderNotIncluded(): boolean {
    return !this.renderIncluded
  }

  // required for i18n

  get old_price(): number {
    return this.bookLaunchOffer?.product?.currencyPrice(this.currency) || 0
  }

  get new_price(): number {
    return this.tier?.currencyBookPrice(this.currency) || 0
  }

  // freeCopies
  get quantity(): number {
    const quantity = this.tier?.quantity || 0

    if (quantity > 100) {
      return 20
    } else if (quantity > 50) {
      return 10
    } else if (quantity > 20) {
      return 4
    } else if (quantity > 10) {
      return 2
    } else {
      return 0
    }
  }

}
